import { constants } from '../constant/constant';
import { SMTP_SETTINGS } from '../constant/actionTypes';
import { httpservice, httpserviceWithMultipart } from '../services';

export const getSmtpSettings = () => (dispatch) => {
  const query = `${constants.API.SMTP_SETTINGS}`;

  dispatch({
    payload: [],
    type: SMTP_SETTINGS.GET.INITIATE,
  });
  return httpservice()
    .get(query)
    .then((response) => {
      let rows = [];
      let count = 0;
      if (response.data.response.length) {
        rows = response.data.response;
        count = response.data.response.length;
      } else {
        rows = response.data.response.rows;
        count = response.data.response.count;
      }

      // let data = response.data.response.smtp;
      const responseData = rows && rows.length ? rows.map((data) => (
        {
          ...data,
          mail_host: data.host,
          mail_port: data.port,
          mail_user: data.user,
          mail_pass: data.pass,
          mail_encryption: data.encryption,
        }
      )) : [];

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: SMTP_SETTINGS.GET.SUCCESS,
      });
      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: SMTP_SETTINGS.GET.ERROR,
      });
    });
};

export const verifySmtpSettings = (object) => (dispatch) => {
  const apiEndPoint = constants.ADMIN_URL + constants.API.VERIFY_SMTP_SETTINGS;

  return httpserviceWithMultipart('post', object, apiEndPoint)
    .then((response) => {
      dispatch({
        payload: { data: response.data },
        type: SMTP_SETTINGS.VERIFY.SUCCESS,
      });

      return { status: 1, data: response.data };
    }).catch((error) => ({ status: 0, data: error.response && error.response.data ? error.response.data : error }));
};

export const saveSmtpSettings = (object) => (dispatch) => {
  const apiEndPoint = constants.ADMIN_URL + constants.API.SMTP_SETTINGS;

  return httpserviceWithMultipart('post', object, apiEndPoint)
    .then((response) => {
      dispatch({
        payload: { data: response.data },
        type: SMTP_SETTINGS.VERIFY.SUCCESS,
      });

      return { status: 1, data: response.data };
    }).catch((error) => ({ status: 0, data: error.response && error.response.data ? error.response.data : error }));
};
